import { getEnterpriseNoInvoice } from "../repository/report.repository";

export const GetEnterpriseNoInvoice = async (params) => {
  try {
    const response = await getEnterpriseNoInvoice(params);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
